module.exports = __webpack_public_path__ + "Roboto-Light.a9b3078b5cb44331ce0e.woff";


//////////////////
// WEBPACK FOOTER
// /Users/vladislavlazurenko/IdeaProjects/luiziana/frontend/src/roboto-fontface/fonts/roboto/Roboto-Light.woff
// module id = ../../../../../src/roboto-fontface/fonts/roboto/Roboto-Light.woff
// module chunks = styles